import { internalAxios } from '../../utils/axios/internal';

export const articlesForArtist = async idartist => {
  const response = await internalAxios.get(`/api/wallet/ami/articles/${idartist}`);
  return response.data;
};
